module.exports = __webpack_public_path__ + "static/media/Bedside.4c46d00a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/iLocal-Delivery-Icons/Bedside.svg
// module id = 959
// module chunks = 0